import * as types from '../actions/_actionTypes';
import initialState from './_initialReducerState'

export default function SupplierconsumptionReducer(state = initialState.supplierconsumption, action: any) {
  switch (action.type) {
    case types.SAVE_SUPPLIERCONSUMPTION_SUCCESS:
      return action.supplierconsumption;
    default:
      return state;
  }
}
